import { RoundedContentSection } from 'app/agriculture/components/RoundedContentBox/RoundedContentSection';
import { Skeleton } from '@mui/material';
import { ContentBox } from 'app/agriculture/components/ContentBox/ContentBox';

export function DeviceOfflineContentSkeleton() {
    return (
        <ContentBox.Section disableDivider>
            <RoundedContentSection heading="Offline device information">
                <h5>
                    <Skeleton variant="text" />
                </h5>
                <p>
                    <Skeleton variant="text" height={40} />
                </p>
            </RoundedContentSection>
        </ContentBox.Section>
    );
}
